import React, { useEffect, useRef } from "react";
import AliceCarousel from "react-alice-carousel";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import useTestimonialsFetch from "../../../hooks/useTestimonialsFetch";
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

//  Styles
import "./Testimonials.scss";

//  Components
import TestimonialBox from "../../../components/TestimonialBox";
import Spinner from "../../../components/Spinner";

const Testimonials = () => {
  gsap.registerPlugin(ScrollTrigger);
  let items = [];
  const { state, error, loading } = useTestimonialsFetch();

  const handleDragStart = (e) => e.preventDefault();
  //  GSAP references
  const testimonialsRef = useRef([]);
  testimonialsRef.current = [];

  const calcDelay = (index) => {
    if (index === 0) return index;
    return index - index * 0.7;
  };

  useEffect(() => {
    state.forEach((t) => {
      items.push(
        <TestimonialBox
          testimonial={t}
          onDragStart={handleDragStart}
          role="presentation"
        />
      );
    });

    testimonialsRef.current.forEach((el, index) => {
      gsap.fromTo(
        el,
        {
          autoAlpha: 0,
          y: 50,
        },
        {
          autoAlpha: 1,
          y: 0,
          delay: calcDelay(index),
          scrollTrigger: {
            id: "testemunhos",
            trigger: el,
            start: "top center+=100",
          },
        }
      );
    });
  });

  const addToRefs = (el) => {
    if (el && !testimonialsRef.current.includes(el)) {
      testimonialsRef.current.push(el);
    }
  };

  return (
    <div id="testemunhos" className="block">
      <Container>
        <h2 className="text-center title" ref={addToRefs}>
          Testimonials 📥
        </h2>
        <h4 className="subtitle text-center mb-4" ref={addToRefs}>
          These are the testimonies of clients who have used my services. If you
          want to leave some, send me a message{" "}
          <Link to="/contact" className="text-danger">
            here
          </Link>
          .
        </h4>
        {loading && <Spinner color="red" />}
        <div ref={addToRefs} className="py-3">
          {error && !loading ? (
            "⚠️ There was an error while loading the testimonials."
          ) : (
            <AliceCarousel
              autoPlay
              autoPlayStrategy="all"
              controlsStrategy="responsive"
              disableButtonsControls
              disableDotsControls
              infinite
              mouseTracking
              autoPlayInterval={5000}
              responsive={{
                0: {
                  items: 1,
                },
                1024: {
                  items: 2,
                },
              }}
              items={items}
            />
          )}
        </div>
      </Container>
    </div>
  );
};

export default Testimonials;
